import React from 'react';
import RegisterPaywall from '../../components/registerpaywall';

const RegisterPaywallContainer = () => <RegisterPaywall />;

export default RegisterPaywallContainer;
